import { Vue, Component } from 'vue-property-decorator';
import '@/registerVuePlugins';

import { default as TaskGroupsPage } from './Components/TaskGroupsPage.vue';

@Component({
  name: 'task-groups-component',
  components: { TaskGroupsPage }
})
class TaskGroupsComponent extends Vue {
  public verificationToken: string = '';

  public async mounted() {
    this.verificationToken = await this.$verificationToken();
  }
}

new TaskGroupsComponent()
  .$mount('#task-groups-view');